import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Intro from './views/Intro.vue'


// import Info from './views/Info.vue'
// import InfoSlider from './views/InfoSlider.vue'
// import BurleMarx from './views/BurleMarx.vue'
// import BurleMarxCreate from './views/BurleMarxCreate.vue'
// import BurleMarxLive from './views/BurleMarxLive.vue'
// import BurleMarxPlay from './views/BurleMarxPlay.vue'
// import BurleMarxQuiz from './views/BurleMarxQuiz.vue'
// import AllMedia from './views/AllMedia.vue'
// import ImageSlider from './views/ImageSlider.vue'
// import GardenMap from './views/GardenMap.vue'
// import FlyoverMap from './views/FlyoverMap.vue'
// import PlantfluencerList from './views/PlantfluencerList.vue'
// import Plantfluencer from './views/Plantfluencer.vue'
// import RecipeList from './views/RecipeList.vue'
// import Recipe from './views/Recipe.vue'
// import IframePage from './views/IframePage.vue'
// import ConservatoryPano from './views/ConservatoryPano.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [

    /**
     * Below here, global routes leading to all experiences
     */
    {
      path: '/',
      name: 'home',
      component: Home
    },

    {
      path: '/choose',
      name: 'choose',
      component: Intro
    },

    /**
     * Below here, routes for the Burle Marx experience
     */
    // {
    //   path: '/burle-marx',
    //   name: 'burle-marx-intro',
    //   component: Info,
    //   props: {
    //     title: 'Burle Marx',
    //     page: 'sample-page',
    //     routeName: 'burle-marx'
    //   }
    // },
    // {
    //   path: '/burle-marx/entry',
    //   name: 'burle-marx',
    //   component: BurleMarx
    // },
    // // CREATE LIKE
    // {
    //   path: '/burle-marx/create',
    //   name: 'burle-marx-create',
    //   component: BurleMarxCreate
    // },
    // {
    //   path: '/burle-marx/create/see-from-above',
    //   name: 'burle-marx-create-flyover',
    //   component: FlyoverMap,
    //   props: {
    //     exhibitGroup: 'flyover-map'
    //   }
    // },
    // {
    //   path: '/burle-marx/create/virtual-landscape/intro',
    //   name: 'burle-marx-create-virtual-landscape-intro',
    //   component: Info,
    //   props: {
    //     page: 'sample-page',
    //     routeName: 'burle-marx-create-virtual-landscape-intro-slider'
    //   }
    // },
    // {
    //   path: '/burle-marx/create/virtual-landscape/intro-slider',
    //   name: 'burle-marx-create-virtual-landscape-intro-slider',
    //   component: InfoSlider,
    //   props: {
    //     routeName: 'burle-marx-create-virtual-landscape'
    //   }
    // },
    // {
    //   path: '/burle-marx/create/virtual-landscape',
    //   name: 'burle-marx-create-virtual-landscape',
    //   component: IframePage,
    //   props: {
    //     src: process.env.BASE_URL + 'frames/virtual-landscape/',
    //     title: 'Virtual Landscape'
    //   }
    // },
    // // LIVE LIKE
    // {
    //   path: '/burle-marx/live',
    //   name: 'burle-marx-live',
    //   component: BurleMarxLive
    // },
    // {
    //   path: '/burle-marx/live/plant-personality',
    //   name: 'burle-marx-live-plant-personality',
    //   component: BurleMarxQuiz,
    //   props: {
    //     src: process.env.BASE_URL + 'frames/quiz/',
    //     title: 'Find Your Plant Personality'
    //   }
    // },
    // {
    //   path: '/burle-marx/live/plant-personality/intro',
    //   name: 'burle-marx-live-plant-personality-intro',
    //   component: Info,
    //   props: {
    //     page: 'sample-page',
    //     routeName: 'burle-marx-live-plant-personality'
    //   }
    // },
    // {
    //   path: '/burle-marx/live/plantfluencers',
    //   name: 'burle-marx-live-plantfluencers',
    //   component: PlantfluencerList
    // },
    // {
    //   path: '/burle-marx/live/plantfluencers/intro',
    //   name: 'burle-marx-live-plantfluencers-intro',
    //   component: Info,
    //   props: {
    //     page: 'sample-page',
    //     routeName: 'burle-marx-live-plantfluencers'
    //   }
    // },
    // {
    //   path: '/burle-marx/live/plantfluencers/:plantfluencer',
    //   name: 'burle-marx-live-plantfluencer',
    //   component: Plantfluencer,
    //   props: true
    // },
    // // PLAY LIKE
    // {
    //   path: '/burle-marx/play',
    //   name: 'burle-marx-play',
    //   component: BurleMarxPlay
    // },
    // {
    //   path: '/burle-marx/play/sitio',
    //   name: 'burle-marx-play-sitio',
    //   component: RecipeList
    // },
    // {
    //   path: '/burle-marx/play/sitio/intro',
    //   name: 'burle-marx-play-sitio-intro',
    //   component: Info,
    //   props: {
    //     page: 'sample-page',
    //     routeName: 'burle-marx-play-sitio'
    //   }
    // },
    // {
    //   path: '/burle-marx/play/sitio/:recipe',
    //   name: 'burle-marx-play-sitio-recipe',
    //   component: Recipe,
    //   props: true
    // },
    // {
    //   path: '/burle-marx/play/playlist',
    //   name: 'burle-marx-play-playlist',
    //   component: Info
    // },
    // {
    //   path: '/burle-marx/play/playlist/intro',
    //   name: 'burle-marx-play-playlist-intro',
    //   component: Info,
    //   props: {
    //     page: 'sample-page',
    //     routeName: 'burle-marx-play-playlist'
    //   }
    // },

    // {
    //   path: '/burle-marx/garden-map',
    //   name: 'burle-marx-garden-map',
    //   component: GardenMap,
    //   props: {
    //     exhibitGroup: 'garden-map'
    //   }
    // },


    // /**
    //  * Below, Conservatory routes
    //  */
    // {
    //   path: '/conservatory',
    //   name: 'conservatory',
    //   component: Info,
    //   props: {
    //     title: 'Conservatory',
    //     page: 'sample-page',
    //     routeName: 'conservatory-explore'
    //   }
    // },
    // {
    //   path: '/conservatory/explore',
    //   name: 'conservatory-explore',
    //   component: ConservatoryPano,
    // },
    // {
    //   path: '/conservatory/view/:exhibitslug',
    //   name: 'conservatory-view',
    //   component: AllMedia,
    //   props: true,
    // },
    // {
    //   path: '/exhibit/:exhibitslug/photos/:slide?',
    //   name: 'exhibitslider',
    //   component: ImageSlider,
    //   props: true
    // },

    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // }
  ]
})
